import Vue from 'vue'
import VueRouter from 'vue-router'
import Sign from '@/views/Sign/index.vue'
import {
  getToken
} from '@/utils/auth'
import {
  checkToken
} from '@/api/user'
import wxshare from '@/utils/wxshare'

Vue.use(VueRouter)

const routes = [{
    path: '/sign',
    name: 'Sign',
    component: Sign,
    meta: {
      keepAlive: true
    }
  },
  {
    path: '/',
    name: 'Home',
    component: () => import('@/views/Home/index.vue'),
    meta: {
      keepAlive: true,
      transition: false,
      auth: true,
    }
  },
  {
    path: '/reset',
    name: 'Reset',
    component: () => import('@/views/Reset/index.vue'),
    meta: {
      transition: true
    }
  },
  {
    path: '/detail',
    name: 'Detail',
    component: () => import('@/views/Detail/index.vue'),
    meta: {
      transition: true,
      auth: true,
      back: true,
    }
  },
  {
    path: '/credit',
    name: 'Credit',
    component: () => import('@/views/Credit/index.vue'),
    meta: {
      transition: true,
      auth: true,
      back: true,
    }
  },
  {
    path: '/game',
    name: 'Game',
    component: () => import('@/views/Game/index.vue'),
    meta: {
      transition: true,
      auth: true,
    }
  },
  {
    path: '/index',
    name: 'Index',
    component: () => import('@/views/Index/index.vue')
  },
  {
    path: '/upload',
    name: 'Upload',
    component: () => import('@/views/Upload/index.vue'),
    meta: {
      transition: true,
      auth: true,
      back: true,
    }
  },
]

const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}

const router = new VueRouter({
  routes
})

router.beforeEach((to, from, next) => {
  
  if (!window.shareset) {
    wxshare.ShareLocal("坪山区第一届“华裔青少年线上夏令营”即将开课！", "点击进入报名通道", `https://activity.sznews.com/front/psxly2021_front/${require("@/assets/share.jpg")}`, "https://activity.sznews.com/front/psxly2021_front/#/sign", "")
    window.shareset = true
  }

  // if(to.name != 'Sign') {
  //   next({
  //     path: '/sign'
  //   })
  // }else {
  //   next()
  // }
  // return


  if (to.meta.auth) {

    // 前往非登录或非注册页 判断是否存在x-token且未过期 即是否已登录

    if (getToken()) {
      checkToken(getToken()).then(res => {
        if (res.data != null) {
          Vue.prototype.$global.realname = res.data.realname;
          next()
        } else {
          next({
            path: '/sign',
            replace: true
          })
        }


      }).catch(rej => {
        next({
          path: from.name == 'Sign' ? '/index' : '/sign',
          replace: true
        })
      })

    } else {

      if (from.name == 'Sign') {
        next({
          path: '/index',
          replace: true
        })
      } else {
        next({
          path: '/sign',
          replace: true
        })
      }
      // 未登录或token过期 重定向至登录页

    }

  } else {
    // 前往登录或注册页
    next();
  }



})

export default router